// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@conklin/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = {
    css: css`
        display: flex;
        align-items: flex-start;
        gap: 12px;
        max-width: 100%;
        flex: 1;

        & > div {
            flex: 1;
            ${xScreen("lte", "sm")} {
                min-width: calc(50% - 6px);
                max-width: calc(50% - 6px);
            }
        }
    `,
};

dateRangeStyles.searchFieldWrapper = {
    wrapper: {
        css: css`
            width: 100%;
            flex: 1 1 30%;
            min-width: 324px;
            display: flex;

            ${xScreen("lte", "md")} {
                flex: 1;
                min-width: calc(50% - 6px);
                max-width: calc(50% - 6px);
            }

            ${xScreen("lte", "sm")} {
                min-width: 100%;
                max-width: 100%;
            }
        `,
    },
};

dateRangeStyles.fromDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.fromDate, {
        cssOverrides: {
            formField: css`
                display: flex;
            `,
            datePicker: css`
                .react-calendar {
                    left: 0;
                    right: unset;
                }
            `,
        },
    }),
};

dateRangeStyles.toDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.toDate, {
        cssOverrides: {
            formField: css`
                display: flex;
            `,

            datePicker: css`
                .react-calendar {
                    right: 0;
                    left: unset;
                }
            `,
        },
    }),
};
